import React from "react";
import { Typography } from "@mui/material";
import { CenteredModal, FeedbackModalContent, ZoomInstructions } from "./FAQSearch.style";

const PrinterCallBox = ({ open, onClose }) => {
  return (
    <CenteredModal
      open={open}
      onClose={onClose}
      aria-labelledby="printer-call-modal"
    >
      <FeedbackModalContent style={{ width: '350px', maxWidth: '90vw' }}>
        <Typography variant="subtitle1" style={{ marginBottom: '16px', fontWeight: 'bold' }}>
          Call Printer Support @  <u><b>91874666</b></u>
        </Typography>
        <ZoomInstructions variant="caption" fontFamily={'RobotoRegular'} style={{display: 'block' }}>
          We don't handle printer issues on our side. Please contact printer support directly.
        </ZoomInstructions>
      </FeedbackModalContent>
    </CenteredModal>
  );
};

export default PrinterCallBox;
